<template>
    <v-container>
        <v-row>
            <v-col>
                <h1>Parent/Guardian Information</h1>
            </v-col>
        </v-row>
        <div v-if="afterMounted == true">
            <p>To ensure that we have have the most current contact information for your parents or guardians, we kindly
                request the following details from you. It's important to note that student educational records are
                protected by the <a
                    href="https://www.adelphi.edu/policies/privacy-and-release-of-student-education-records/"><strong>Family
                        Educational Rights and Privacy Act (FERPA).</strong></a> This means that
                information such as grades and financial aid details will not be shared with parents or guardians without
                your
                consent; disclosure is purely voluntary.</p>
            <br>
            <p>
                Parents and families are an important part of the Adelphi community. We use their parent/guardian contact
                information to help families stay informed and to help students reach their higher education goals,
                including academic and career success.
            </p>
            <br>
            <p>
                Parent/guardian contact information will be retained on a student's record and used to share information
                about campus events as well as important academic dates, deadlines and financial resources; we will also
                reach out to help explain what parents can expect from their student's years in college.
            </p>
            <!-- <div v-if="this.pg_data.length !== 0"> -->
            <v-form ref="pg_form" lazy-validation >
            <div>
                <v-container v-for="item in this.pg_data" v-bind:key="item._ID" :id="item._ID" ref="{{ item._ID }}">
                    <h4>Name</h4>  
                    <v-row>
                        <v-col cols="12" sm="6" >
                            <v-text-field outlined required :rules="requiredRules" aria-label="First Name" label="First Name" v-model="item.PGD_First" />
                        </v-col>
                        <v-col cols="12" sm="">
                            <v-text-field outlined required :rules="requiredRules" aria-label="Last Name" label="Last Name" v-model="item.PGD_Last" />
                        </v-col>
                    </v-row>

                    <h4>Phone</h4>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field outlined required :rules="requiredRules" aria-label="Mobile Phone" label="Mobile Phone"
                                v-model="item.PGD_MobilePhone" />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field outlined aria-label="Home Phone" label="Home Phone"
                                v-model="item.PGD_HomePhone" />
                        </v-col>
                    </v-row>
                    <h4>Address</h4>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-text-field outlined required :rules="requiredRules" aria-label="Street Address" label="Street Address"
                                v-model="item.PGD_Address" :class="item.inputClass" />
                        </v-col>
                        <v-col cols="12" sm="12">
                            <v-text-field outlined aria-label="Address Line 2" label="Address Line 2"
                                v-model="item.PGD_Address_2" />
                        </v-col>
                        <v-col cols="12" sm="5">
                            <v-text-field outlined required :rules="requiredRules" aria-label="City" label="City" v-model="item.PGD_City" />
                        </v-col>
                        <v-col cols="12" sm="5">
                            <!--
                            <v-text-field outlined aria-label="State / Province / Region" label="State / Province / Region"
                                v-model="item.PGD_State" /> -->
                            <v-combobox 
                                outlined 
                                aria-label="State / Province / Region" 
                                label="State / Province / Region" 
                                :items=states
                                v-model="item.PGD_State" >
                            </v-combobox>
                        </v-col>
                       
                        <v-col cols="12" sm="5">
                            <v-text-field outlined aria-label="Zip / Postal Code" label="Zip / Postal Code"
                                v-model="item.PGD_Zip" />
                        </v-col>
                        <v-col cols="12" sm="5">
                            <!--
                            <v-text-field outlined required :rules="requiredRules" aria-label="Country" label="Country" v-model="item.PGD_Country" /> -->
                            <v-select
                                v-model="item.PGD_Country"
                                :rules="countryRules"
                                :items="country"
                                aria-label="Country"
                                class="messages"
                                outlined
                                single-line
                                density="comfortable"
                                required
                                menu-props="auto"
                                
                            />
                        </v-col>
                    </v-row>
                    <v-row>

                    </v-row>
                    <v-row>
                        <h4>Email</h4>
                        <v-col cols="12" sm="12">
                            <v-text-field outlined required :rules="requiredRules" aria-label="Email Address" label="Email Address"
                                v-model="item.PGD_Email" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <h4>Your relationship to contact</h4>
                        <v-col cols="12" sm="12">
                            <!--
                                <v-text-field outlined required :rules="requiredRules" aria-label="Relationship" label="Relationship"
                                v-model="item.PGD_Relationship" /> -->
                            <v-combobox 
                                outlined 
                                required 
                                :rules="requiredRules"
                                aria-label="Relationship" 
                                label="Relationship" 
                                :items=relationships
                                v-model="item.PGD_Relationship" >
                            </v-combobox>

                        </v-col>
                    </v-row>
                    <v-row>
                        <h4>Title of organization</h4>
                        <p>(Optional): This information will be used by the University to reach out to potential partners to
                            offer discounts, affinity programs, and other engagement activities.</p>
                        <v-col cols="12" sm="12">
                            <v-text-field outlined aria-label="Name of Employer" label="Name of Employer"
                                v-model="item.PGD_Employer" />
                        </v-col>
                    </v-row>
                    <!-- <button @click="removeContact(item._ID)">Remove Contact</button> -->
                    <v-btn class="add-remove-btn" padding-bottom="6px" @click="removeContact(item._ID)" :loading="loading" :disabled="loading">
                        <v-icon left color="#FF6347"> mdi-minus-circle </v-icon>
                        Remove Contact
                    </v-btn>
                    <hr />
                </v-container>

                <v-btn v-if="pg_data.length < 4" class="add-remove-btn" padding-bottom="6px" @click="addContact" :loading="loading" :disabled="loading">
                    <v-icon left color="#1E90FF"> mdi-plus-circle </v-icon>
                    Add More Contacts 
                </v-btn>
            </div>

            <template>
                <v-dialog v-model="addressSuggestion" persistent width="750"  class="pl-4">
                    <v-card>
                        <v-card-title>
                            We were not able to verify your address(s), but found a close match:
                        </v-card-title>
                        <v-card-text v-for="(value, key) in this.suggestionObj" :key="key">
                            <v-container v-if="value" class="addrDialog">
                            <v-row>
                                <v-col cols="12" md="6" sm="6"  class="pr-0 mr-0 pt-4">
                                    <div class="addrSubtitle">{{ suggestDialog[key] }}Address Entered:</div>
                                    <div class="pl-2">{{ value.street }}</div> 
                                    <div class="pl-2" v-if="value.street2">{{ value.street2 }}</div>
                                    <div class="pl-2">{{ value.city }}, {{ value.state }} {{ value.zipCode }} </div>
                                </v-col>
                                <v-col cols="8" md="6" sm="6" class="ps-0 ml-0 pt-4">
                                    <div class="addrSubtitle">Suggestion:</div>
                                    <div class="pl-2">{{ value.result[0]['deliveryLine1'] }}</div>
                                    <div class="pl-2" v-if="value.result[0]['deliveryLine2']">{{  value.result[0]['deliveryLine2'] }}</div>
                                    <div class="pl-2">{{ value.result[0]['lastLine'] }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-radio-group v-model="acceptSuggest[key]" row mandatory>                                    
                                        <v-col cols="12" md="6" sm="6">
                                            <v-radio class="dialogRadio" label="Continue as entered" value="false" required=true></v-radio>
                                        </v-col>
                                        <v-col cols="8" md="6" sm="6">
                                            <v-radio class="dialogRadio" label="Accept Suggested" value="true" ></v-radio>       
                                        </v-col>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-container>
                        </v-card-text>
                        <v-card-actions>
                                <v-btn class="ml-10" color="#ffb500" @click="() => { addressSuggestion = false; loading = false; }">
                                    Cancel
                                </v-btn>
                                <v-btn class="ml-3" color="#ffb500" @click="addressSuggestion = false; useSuggestion = false; continueSubmission(formDataHolder);">
                                    Submit Changes
                                </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>

            <template>
                <v-dialog v-model="addressError" persistent width="700">
                    <v-card>
                        <v-card-title>
                            {{ addressErrorTitle }}
                        </v-card-title>
                        <v-card-text>
                            <div v-for="(text, index) in addressErrorText.split('\n')" :key="index">
                                {{ text }}
                            </div>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="#ffb500" @click="addressError = false; loading = false;" class="ml-3 mt-5 mb-5" >
                                Okay
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>

            <v-btn @click="this.saveAllChanges" color="#ffb500" :loading="loading" :disabled="loading"
                class="black--text v-btn v-btn--contained theme--light v-size--x-large">Submit Changes</v-btn>
        </v-form>
            <v-dialog v-model="data_saved" persistent max-width="450">
                <v-card>
                    <v-card-title style="white-space: pre-line;">
                        {{ this.dialog_text }}
                    </v-card-title>
                    <v-card-actions>
                        <v-btn @click="data_saved = false; reloadPage();" color="#ffb500">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>


            <v-dialog v-model="validate_msg" persistent max-width="450">
                <v-card>
                    <v-card-title>
                        {{ this.validate_msg_title }}
                    </v-card-title>
                    <v-card-text>{{ this.validate_msg_text }}</v-card-text>
                    <v-card-actions>
                        <v-btn @click="closeDialog();" color="#ffb500">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </div>
    </v-container>
</template>
<script>

import { mask } from "vue-the-mask";
import ClickOutside from "vue-click-outside"
import axios from 'axios'

export default {
    directives: {
        mask,
        ClickOutside
    },
    data: () => ({
        afterMounted: false,
        loading: false,
        data_saved: false,
        validate_msg: false,
        validate_msg_title: "",
        validate_msg_text: "",
        personal_data: null,
        mask: '###-###-####',
        pg_data: [],
        pg_data_ori: [],
        dialog_text: "",
        hasParentOnFile: false,

        //state: [ 'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'NY', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'],
        states: null,
        /*
        country: ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombi', 'Comoros', 'Congo (Brazzaville)', 'Congo', 'Costa Rica', 'Cote d&apos;Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor (Timor Timur)', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon', 'Gambia, The', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, North', 'Korea, South', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia and Montenegro', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'US', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'],*/

        country: [
"",
"Afghanistan",
"Albania",
"Algeria",
"American Samoa",
"Andorra",
"Angola",
"Anguilla",
"Antarctica",
"Antigua and Barbuda",
"Argentina",
"Armenia",
"Aruba",
"Australia",
"Austria",
"Azerbaijan",
"Bahrain",
"Bangladesh",
"Barbados",
"Belarus",
"Belgium",
"Belize",
"Benin",
"Bermuda",
"Bhutan",
"Bolivia",
"Bosnia and Herzegovina",
"Botswana",
"Bouvet Island",
"Brazil",
"British Virgin Islands",
"Brunei",
"Bulgaria",
"Burkina Faso",
"Burma",
"Burundi",
"Cambodia",
"Cameroon",
"Canada",
"Cape Verde",
"Cayman Islands",
"Central African Republic",
"Chad",
"Chile",
"China",
"Christmas Island",
"Cocos (Keeling) Islands",
"Colombia",
"Comoros",
"Cook Islands",
"Costa Rica",
"Côte d'Ivoire",
"Croatia",
"Cuba",
"Cyprus",
"Czech Republic",
"Democratic Republic of the Congo",
"Denmark",
"Djibouti",
"Dominica",
"Dominican Republic",
"Ecuador",
"Egypt",
"El Salvador",
"Equatorial Guinea",
"Eritrea",
"Estonia",
"Eswatini",
"Ethiopia",
"Falkland Islands (Malvinas)",
"Faroe Islands",
"Fiji",
"Finland",
"France",
"French Guiana",
"French Polynesia",
"Gabon",
"Georgia",
"Germany",
"Ghana",
"Gibraltar",
"Greece",
"Greenland",
"Grenada",
"Guadeloupe",
"Guam",
"Guatemala",
"Guernsey",
"Guinea",
"Guinea-Bissau",
"Guyana",
"Haiti",
"Heard Island and McDonald Islands",
"Holy See (Vatican City State)",
"Honduras",
"Hong Kong",
"Hungary",
"Iceland",
"India",
"Indonesia",
"Iran",
"Iraq",
"Ireland",
"Isle of Man",
"Israel",
"Italy",
"Jamaica",
"Japan",
"Jersey",
"Jordan",
"Kazakhstan",
"Kenya",
"Kiribati",
"Kosovo",
"Kuwait",
"Kyrgyzstan",
"Laos",
"Latvia",
"Lebanon",
"Lesotho",
"Liberia",
"Libya",
"Liechtenstein",
"Lithuania",
"Luxembourg",
"Macao",
"Macedonia",
"Madagascar",
"Malawi",
"Malaysia",
"Maldives",
"Mali",
"Malta",
"Marshall Islands",
"Martinique",
"Mauritania",
"Mauritius",
"Mayotte",
"Mexico",
"Micronesia, Federated States of",
"Moldova",
"Monaco",
"Mongolia",
"Montenegro",
"Montserrat",
"Morocco",
"Mozambique",
"Namibia",
"Nauru",
"Nepal",
"Netherlands",
"Netherlands Antilles",
"New Caledonia",
"New Zealand",
"Nicaragua",
"Niger",
"Nigeria",
"Niue",
"Norfolk Island",
"North Korea",
"Northern Mariana Islands",
"Norway",
"Oman",
"Pakistan",
"Palau",
"Palestine",
"Panama",
"Papua New Guinea",
"Paraguay",
"Peru",
"Philippines",
"Pitcairn",
"Poland",
"Portugal",
"Puerto Rico",
"Qatar",
"Republic of the Congo",
"Romania",
"Russia",
"Rwanda",
"Saint Helena, Ascension and Tristan da Cunha",
"Saint Kitts and Nevis",
"Saint Lucia",
"Saint Pierre and Miquelon",
"Saint Vincent and the Grenadines",
"Samoa",
"San Marino",
"Sao Tome and Principe",
"Saudi Arabia",
"Senegal",
"Serbia",
"Seychelles",
"Sierra Leone",
"Singapore",
"Slovakia",
"Slovenia",
"Solomon Islands",
"Somalia",
"South Africa",
"South Georgia and the South Sandwich Islands",
"South Korea",
"South Sudan",
"Spain",
"Sri Lanka",
"Sudan",
"Suriname",
"Svalbard and Jan Mayen",
"Sweden",
"Switzerland",
"Syria",
"Taiwan",
"Tajikistan",
"Tanzania",
"Thailand",
"The Bahamas",
"The Gambia",
"Timor-Leste",
"Togo",
"Tokelau",
"Tonga",
"Trinidad and Tobago",
"Tunisia",
"Turkey",
"Turkmenistan",
"Turks and Caicos Islands",
"Tuvalu",
"U.S. Virgin Islands",
"Uganda",
"Ukraine",
"United Arab Emirates",
"United Kingdom",
"United States",
"Uruguay",
"Uzbekistan",
"Vanuatu",
"Venezuela",
"Vietnam",
"Wallis and Futuna",
"Western Sahara",
"Yemen",
"Zambia",
"Zimbabwe",            
        ], 

        //{key: 'NO', value: 'Choose Not to Specify'}, 
        tooltips: {
            legal_name: 'This is the legal name listed on your official W2 forms and may also be needed to ensure the accuracy of claims with benefits. If you change your legal name, please contact Human Resources.',
            pronoun: 'Your pronouns will be displayed on the public directory to help us address you properly.',
            preferred_name: 'The name that you commonly use which is different from your legal name.',
            vietnam: 'Having served between August 1964 and May 7, 1975.',
            hispanic: 'A person of Cuban, Mexican, Puerto Rican, South or Central American, or any other Spanish culture or origin regardless of race.',
            asian: 'A person having origins in the Far East, Southeast Asia, or the Indian subcontinent: including but not limited to Cambodia, China, India, Japan, Korea, Malaysia, Pakistan, the Philippine Islands, Thailand and Vietnam.',
            black: 'A person having origins in any of the black racial groups of Africa.',
            pacific: 'A person having origins in Hawaii, Guam or other Pacific Islands.',
            indigenous: 'A person having origins in the original peoples of North and South America (including Central America and Alaska), and who maintain tribal affiliation or community attachment.',
            white: 'A person having origins in Europe, the Middle East or North Africa.'
        },

        requiredRules: [(v) => !!v || "Required field cannot be blank."],    
        countryRules: [(v) => !!v || "Country is required"],    

        addressSuggestion: false,
        addressError: false,
        addressErrorTitle: "Alert!",
        addressErrorText: "We were unable to confirm your address as entered, please try again.",
        suggestionObj: {},
        useSuggestion: false,
        formDataHolder: null,

        suggestDialog : {
            "0" : "First ", 
            "1" : "Second " ,
            "2" : "Third ",
            "3" : "Forth", 
        },

        acceptSuggest: {
            0 : false,
            1 : false,
            2 : false,
            3 : false,
        },

        relationships: ["Parent", "Guardian", "Other"],
    
    }),

    mounted() {
        this.afterMounted = true;
        axios.get('./remote-apis/user-api.php?cmd=parent-guardian')
            .then(response => {
                var PGData_property = 'PGData';   
                
                if (response.data.ROOT != null && PGData_property in response.data.ROOT) {                    
                    if (response.data.ROOT.PGData['_ID'] && !response.data.ROOT.PGData.length) {
                        // _ID is defined and length is undefined, normally means it has only one parent, SAAS return a single dimentional array
                        this.pg_data.push(response.data.ROOT.PGData) ;
                    } else {
                        this.pg_data = response.data.ROOT.PGData;
                    }
                   
                    for (let pd_count = 0; pd_count < this.pg_data.length; pd_count++) {
                        //do decodeURIComponent()
                        Object.keys(this.pg_data[pd_count]).forEach(key => {
                            let val = this.pg_data[pd_count][key] ;
                            if (val === null || val == "null") {
                                val = "";
                            }
                            this.pg_data[pd_count][key] = decodeURIComponent(val.replace(/\+/g, ' '));
                        });
                        // decode the %40 sign to @
                        //if (this.pg_data[pd_count]['PGD_Email']) {
                        //    this.pg_data[pd_count]['PGD_Email'] = decodeURIComponent(this.pg_data[pd_count]['PGD_Email']);
                        this.pg_data[pd_count]['inputClass'] = "pgAddr_" + pd_count ;
                    }
                    this.hasParentOnFile = true;
                    
                } else {
                    this.pg_data.push({
                        "_ID": "",
                        "PGD_PGID": "",
                        "PGD_First": "",
                        "PGD_Last": "",
                        "PGD_MobilePhone": "",
                        "PGD_HomePhone": "",
                        "PGD_Address": "",
                        "PGD_Address_2": null,
                        "PGD_City": "",
                        "PGD_State": "",
                        "PGD_Zip": "",
                        "PGD_Country": "United States",
                        "PGD_Email": "",
                        "PGD_Relationship": "",
                        "PGD_Employer": "",
                        "inputClass": "pgAddr_0",
                    });
                }
                this.pg_data_ori = this.pg_data;
            })
            .catch(error => {
                window.console.error(error)
            })

        axios.get('./remote-apis/user-api.php?cmd=pgp')
            .then(response => {
                this.preferred_pronouns = response.data.ROOT.PREF_GENDER_PRONOUNS
            })
            .catch(error => {
                window.console.error(error)
            })

        axios.get('./remote-apis/user-api.php?cmd=st')
            .then(response => {
                var tmp_states = response.data.ROOT.STATES ;
                this.states = tmp_states.map(({ Description }) => Description);
            })
            .catch(error => {
                window.console.error(error)
            })
    },

    computed: {
        sorted_pronouns: function () {
            function compare(a, b) {
                if (a.Description < b.Description) {
                    return -1
                }
                if (a.Description > b.Description) {
                    return 1
                }
                return 0
            }
            return this.preferred_pronouns.slice().sort(compare)
        }
    },

    methods: {

        sortPronouns: function (a, b) {
            if (a['Description'] === b['Description']) {
                return 0
            } else {
                return (a[0] < b[0]) ? -1 : 1
            }
        },

        isIntl(country) {
            if (country == "United States")
                return false;
            else
                return true;
        },

        saveAllChanges: function () {

            if (this.$refs.pg_form.validate() == false) {
                this.validate_msg_title = "Required fields cannot be blank." ;
                this.validate_msg_text = "Please review your entries.";
                this.validate_msg = true;
                this.loading = false;                     
                return;  
            }
            //let self = this
            this.loading = true
            let formData = new FormData();
            let parentTotal = this.pg_data.length;
            let intlProcessed = 0;
            let parentOriTotal = this.pg_data_ori.length;
            let del_processed = 0;
            var pg = null;

           ///// let pg_found = false;

            if (parentTotal <= 0) {
                if (!this.hasParentOnFile) {
                    // user has no parent data saved on SAAS, not adding a parent but hitting submit changes button, return error.
                    this.validate_msg_title = "No information submitted." ;
                    this.validate_msg_text = "Please click 'Add More Contacts' and submit Parent/Guardian Information.";
                    this.validate_msg = true;
                    this.loading = false;                     
                    return;  
                } else {
                    // deleting all parents on SAAS
                    for (const pg_o in this.pg_data_ori) {  // looping original parent data
                        formData = new FormData();
                        for (var o_key in this.pg_data_ori[pg_o]) {
                            formData.append(o_key, this.pg_data_ori[pg_o][o_key]);
                        }
                        formData.append("mode", "delete");

                        axios.post('./remote-apis/save-pg-data.php', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        })
                        .then(response => {
                            del_processed++;
                            if (response.data['res'] == "SAAS_RETURN_OK") {               
                                if (del_processed >= parentOriTotal) {
                                    this.dialog_text = "Your information has been saved.";
                                    this.data_saved = true;
                                    this.loading = false;
                                    return;
                                }
                            } else if (response.data['res'] == "SAAS_RETURN_FAILURE") {
                                this.dialog_text = "Your information cannot be saved. \r\nPlease try again later.";
                                this.data_saved = true;
                                this.loading = false;  
                                return;
                            } else {
                                // shouldn't be here, just error it
                                this.dialog_text = "Your information cannot be saved.";
                                this.data_saved = true;
                                this.loading = false;                     
                                return;  
                            }
                        })
                        .catch(error => {
                            return (
                                alert(error)
                            )
                        })
                    } // loop original parent data
                }
            }

            // saving parents 

            // SmartyStreet
            const SmartySDK = require("smartystreets-javascript-sdk");
            const SmartyCore = SmartySDK.core;
            const Lookup = SmartySDK.usStreet.Lookup;
            let smartyKey = process.env.VUE_APP_SMARTY_KEY;
            const credentials = new SmartyCore.SharedCredentials(smartyKey);
            let clientBuilder = new SmartyCore.ClientBuilder(credentials).withBaseUrl("https://us-street.api.smarty.com/street-address").withLicenses(["us-core-cloud"]);
            let client = clientBuilder.buildUsStreetApiClient();

            var apiPromises = [];            

            for (var k in this.pg_data) {
                pg = this.pg_data[k] ;

                if (this.isIntl(pg['PGD_Country'])) {
                    // do not pass intl addr to Smarty. Push "null" to apiPromise as a place holder
                    apiPromises.push(null);  
                    intlProcessed++;
                } else {               
                    let lookUp = new Lookup();
                    lookUp.street = pg['PGD_Address'];
                    lookUp.street2 = pg['PGD_Address_2'];
                    lookUp.city = pg['PGD_City'] ;
                    lookUp.state =  pg['PGD_State'] ;
                    lookUp.zipCode =  pg['PGD_Zip'] ;
                    lookUp.maxCandidates = 3;
                    lookUp.match = "enhanced";

                    apiPromises.push(this.verify(client, lookUp));    
                    }
                }

                // all addr entered are intl addr. 
                // do not need to pass to Smarty, submit data
                if (parentTotal == intlProcessed) {
                    this.continueSubmission();
                    return;
                }
  
                const getSuggestions = async () => {   
                    return await Promise.all(apiPromises).then((results) => {
                        return results;
                    })
                };

                getSuggestions().then((suggestions) => {
                    for (let i = 0; i < suggestions.length; i++) {
                        if (suggestions[i] == null || suggestions[i].lookups[0].result.length == 0 || suggestions[i].lookups[0].result[0].analysis.enhancedMatch.includes("none")) {
                            if (this.isIntl(this.pg_data[i]['PGD_Country'])) {
                                // intl addr, pass null as a place holder
                                this.suggestionObj[i] = null ;      
                            } else {
                                // smarty verify failed, error and exit. do not process until smarty can verify it
                                self.loading = false;
                                this.addressError = true;
                                this.addressErrorText = "" ;
                                //this.addressErrorText = "We were unable to confirm your " + this.suggestDialog[i] + " address as entered, please try again.";
                                this.addressErrorText = "We were unable to confirm the " + this.suggestDialog[i] + " address as entered below, please try again.\n";
                                this.addressErrorText += suggestions[i].lookups[0].street ;
                                if (suggestions[i].lookups[0].street2) 
                                    this.addressErrorText += " " +  suggestions[i].lookups[0].street2;
                                this.addressErrorText += "\n" ;
                                this.addressErrorText += suggestions[i].lookups[0].city + " " + suggestions[i].lookups[0].state + " " + suggestions[i].lookups[0].zipCode ;
                                this.$nextTick(() => {
                                    document.querySelector('.'+this.pg_data[i]['inputClass']).scrollIntoView({ block: "center", behavior: "smooth" })
                                });
                                this.addressSuggestion = false;
                                return;
                            }
                        } else {
                           if (suggestions[i].lookups[0].result[0].analysis.enhancedMatch.includes("ignored-input") || !this.matchedSmarty(suggestions[i])) {
                                this.suggestionObj[i] = suggestions[i].lookups[0] ;    
                                this.addressSuggestion= true;        
                           } else {
                                this.suggestionObj[i] = null ;  
                           }
                        }
                }
                if (!this.addressSuggestion) {
                    this.continueSubmission();
                    return;
                }
               // this.addressSuggestion= true;
            });         
    }, 

    async verify(client, lookup) {
        return await client.send(lookup);
    },

    continueSubmission() {

        //window.console.log(this.pg_data);
        //window.console.log(this.pg_data_ori);
        //window.console.log(this.suggestionObj);
        //window.console.log(this.acceptSuggest); 

        let formData = new FormData();
        let processed = 0;
        let parentTotal = this.pg_data.length;
        let pg_found = false;

        // saving parents in the online form:
        for (const pg in this.pg_data) {
            // add or update parent one by one:
            formData = new FormData();

            // Accepted Smarty suggestion
            if (this.acceptSuggest[pg] == true || this.acceptSuggest[pg] == "true") { 
                this.pg_data[pg]['PGD_Address'] = this.suggestionObj[pg]['result'][0]['deliveryLine1'] ;
                if (this.suggestionObj[pg]['result'][0]['deliveryLine2'])
                    this.pg_data[pg]['PGD_Address_2'] = this.suggestionObj[pg]['result'][0]['deliveryLine2'];
                else
                    this.pg_data[pg]['PGD_Address_2'] = "";
                this.pg_data[pg]['PGD_City'] = this.suggestionObj[pg]['result'][0]['components']['cityName'] ;
                this.pg_data[pg]['PGD_State'] = this.suggestionObj[pg]['result'][0]['components']['state'];
                this.pg_data[pg]['PGD_Zip'] = this.suggestionObj[pg]['result'][0]['components']['zipCode'] + "-" + 
                    this.suggestionObj[pg]['result'][0]['components']['plus4Code'];
            }

            for (var key in this.pg_data[pg]) {
                formData.append(key, this.pg_data[pg][key]);
            }
            
            axios.post('./remote-apis/save-pg-data.php', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {          
                processed++;
                if (response.data['res'] == "SAAS_RETURN_OK") {
                    if (processed >= parentTotal) {
                        //Finished adding and updating parents.
                        //Check if user is deleting parents:
                        for (const pg_o in this.pg_data_ori) {  // looping original parent data
                            pg_found = false;
                            for (const pg in this.pg_data) {
                                if (this.pg_data[pg]['_ID'] == this.pg_data_ori[pg_o]['_ID']) {
                                    pg_found = true;  // keeping this parent
                                    break;
                                }
                            }
                            if (!pg_found) { // not found, delete this parent
                                formData = new FormData();
                                for (var o_key in this.pg_data_ori[pg_o]) {
                                    formData.append(o_key, this.pg_data_ori[pg_o][o_key]);
                                }
                                formData.append("mode", "delete");
                                    
                                axios.post('./remote-apis/save-pg-data.php', formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                })
                                .then(response => {
                                    if (response.data['res'] == "SAAS_RETURN_OK") {
                                        // do nothing
                                        // exit dialog is placed at the end
                                    } else if (response.data['res'] == "SAAS_RETURN_FAILURE") {
                                        this.dialog_text = "Your information cannot be saved. \r\nPlease try again later.";
                                        this.data_saved = true;
                                        this.loading = false;  
                                        return;
                                    } else {
                                        // shouldn't be here, error exit
                                        this.dialog_text = "Your information cannot be saved.";
                                        this.data_saved = true;
                                        this.loading = false;                     
                                        return;  
                                    }
                                })
                                .catch(error => {
                                    return (
                                        alert(error)
                                    )
                                })

                            } // pg_found == false

                        } // loop original parent data

                        // should have taken care of all add, update and delete at this point
                        this.dialog_text = "Your information has been saved.";
                        this.data_saved = true;
                        this.loading = false;
                        return;

                    } //Finished adding and updating parents.

                } else if (response.data['res'] == "SAAS_RETURN_FAILURE") {
                    this.dialog_text = "Your information cannot be saved. \r\nPlease try again later.";
                    this.data_saved = true;
                    this.loading = false;  
                    return;
                } else {
                    // shouldn't be here, error exit
                    this.dialog_text = "Your information cannot be saved.";
                    this.data_saved = true;
                    this.loading = false;                     
                    return;  
                } 
            })
            .catch(error => {
                return (
                    alert(error)
                )
            }) 
    }   

        },

        removeContact(id) {
            this.pg_data = this.pg_data.filter(function (obj) {
                return obj._ID !== id
            })
        },

        addContact() {
            // can add up to 4 parents
            if (this.pg_data.length < 4) {
                this.pg_data.push({ _ID: null, PGD_PGID: null, PGD_First: null, PGD_Last: null, PGD_MobilePhone: null, PGD_HomePhone: null, PGD_Address: null, PGD_Address_2: null, PGD_City: null, PGD_State: null, PGD_Zip: null, PGD_Country: "United States", PGD_Email: null, PGD_Relationship: null, PGD_Employer: null, inputClass: "pgAddr_"+this.pg_data.length })                
            }
        },

        showTooltip(name) {
            eval('this.show_tooltip_' + name + ' = true')
        },

        hide_legal_name() {
            this.show_tooltip_legal_name = false
        },

        hide_preferred_name() {
            this.show_tooltip_preferred_name = false
        },

        hide_hispanic() {
            this.show_tooltip_hispanic = false
        },

        hide_asian() {
            this.show_tooltip_asian = false
        },

        hide_black() {
            this.show_tooltip_black = false
        },

        hide_pacific() {
            this.show_tooltip_pacific = false
        },

        hide_indigenous() {
            this.show_tooltip_indigenous = false
        },

        hide_white() {
            this.show_tooltip_white = false
        },

        hide_vietnam() {
            this.show_tooltip_vietnam = false
        },
        reloadPage() {
            window.location.reload();
        },
        closeDialog() {
            this.validate_msg = false;
        },    
        matchedSmarty(suggestion) {

            let input_line1 = "" ;
            let input_line2 = "" ;
            let input_lastLineArr = [] ;
            let input_lastLine = "";

            let smarty_line1 = "" ;
            let smarty_line2 = "";
            let smarty_lastLine = "" ;

            if (suggestion.lookups[0].street)
                input_line1 = suggestion.lookups[0].street.trim() ;
            if (suggestion.lookups[0].street2)
                input_line2 = suggestion.lookups[0].street2.trim() ;
            if (suggestion.lookups[0].city)            
                input_lastLineArr.push(suggestion.lookups[0].city.trim());
            if (suggestion.lookups[0].state)
                input_lastLineArr.push(suggestion.lookups[0].state.trim()); 
            if (suggestion.lookups[0].zipCode) {
                input_lastLineArr.push(suggestion.lookups[0].zipCode.trim()) ;
            }    
            input_lastLine = input_lastLineArr.join(" ") ;

            if (suggestion.lookups[0].result[0].deliveryLine1)
                smarty_line1 = suggestion.lookups[0].result[0].deliveryLine1.trim() ;
            if (suggestion.lookups[0].result[0].deliveryLine2)
                smarty_line2 = suggestion.lookups[0].result[0].deliveryLine2.trim() ;
            if (suggestion.lookups[0].result[0].lastLine)
                smarty_lastLine = suggestion.lookups[0].result[0].lastLine.trim() ;

            if (input_line1.toUpperCase() !== smarty_line1.toUpperCase())
                return false;

            if (input_line2.toUpperCase() !== smarty_line2.toUpperCase())
                return false;

            if (input_lastLine.toUpperCase() !== smarty_lastLine.toUpperCase())
                return false;

            return true;

        }
    },
}
</script>

<style>
.inputs-container {
    .col-12 {
        padding-top: 0;
        padding-bottom: 0;
    }
}
.h2 {
    margin: 0px;
}
.h3 {
    margin: 0px;
}
.add-remove-btn {
    background-color: transparent !important;
    /* color: transparent !important; */
    /* webkit-box-shadow: 0px 0px 0px 0px !important; */
    box-shadow: 0px 0px 0px 0px !important;
}

.v-messages__message {
    font-size: 16px !important;
}

.dialogRadio label {
  font-weight: 500 !important;
  font-size: 14px !important;
  width: 40% !important;
}

.suggestHr {
    border-bottom: 1px solid #ffb500 !important;
}

.addrDialog {
    padding-bottom: 0px !important;
    padding-top: 0px !important;
}

.addrSubtitle {
    font-weight: bold !important;
    background-color:#ffb500 !important;
    padding: 4px 4px 4px 8px !important; 
}

.v-card__text {
    padding-bottom: 0px !important;
}

</style>